export default "__VITE_ASSET__BpHpl0H4__"